module.exports = __webpack_public_path__ + "img/thumb_27.5ec5f884.jpg";